import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FieldFilter, FilterModel, OperatorFilterEnum } from 'app/models/filter-model';
import { PaymentModel } from 'app/models/payment-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { Utils } from '../../utils/Utils';
import * as moment from 'moment-timezone';
import { Constants } from 'app/components/utils/Constants';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, catchError, forkJoin, map, of, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserModel } from 'app/models/user';
import { MassiveActions } from 'app/components/shared/filters/filter.component';
import { DataTicketProductModel } from 'app/models/data-ticket-model';
import { Log } from 'app/core/logging/log';
import { DataTableActionColumn, DataTableActionEvent, DataTableSelectionConfig } from 'app/components/shared/data-table/data-table.component';
import { DataTableBadgeTone } from 'app/components/shared/data-table/data-table-badge.component';


@Component({
  selector: 'app-admin-payment',
  templateUrl: './admin-payment.page.html',
  styleUrls: ['./admin-payment.page.scss'],
})
export class AdminPaymentPage implements OnInit, OnDestroy {

  state: 'idle' | 'loading' | 'loaded' | 'error' = 'idle';
  payments: {
    content: PaymentModel[],
    pageNumber: number,
    totalElements: number,
    size: number,
    last: boolean
  } = { totalElements: 50, size: 0, pageNumber: 0, last: false, content: [] };
  resumen: any = {};
  
  totalElements: number = 50;
  pageSize = 10;
  pageIndex = 0;

  fieldFilters: FieldFilter[] = [];
  accions: string[] = [];
  massiveAccions: MassiveActions[] = [
    { key: 'assign_payment', enabled: false }, { key: 'generate_invoices', enabled: false }
  ];

  massiveActionSelected: string = '';

  dataSource = new MatTableDataSource<PaymentModel>;
  displayedColumns = ['select', 'totalPrice', 'status', 'type', 'createdAt', 'invoiceNumber', 'actions'];
  selection = new SelectionModel<PaymentModel>(true, []);
  readonly selectionColumnConfig: DataTableSelectionConfig<PaymentModel> = {
    selection: this.selection,
    canSelect: (row) => this.validationAction(row)
  };
  readonly paymentActionColumn: DataTableActionColumn<PaymentModel> = {
    align: 'end',
    actions: [
      {
        key: 'cancel',
        label: this.appService.getTraduccion('finance.payment.table.header.action'),
        variant: 'flat',
        className: 'cancel-btn',
        disabled: (row) => !this.isCancelable(row)
      }
    ]
  };
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  private searchSub?: Subscription;
  private summarySub?: Subscription;

  constructor(
    private dialog: MatDialog,
    private restService: RestService,
    public appService: AppService) { }

  ngOnInit() {
    //this.getPayments();
    this.fieldFilters.push({
      name: 'status',
      type: 'select',
      multiple: true,
      value: ['CAPTURE', 'REFUNDED'],
      values: ['CAPTURE', 'REFUNDED'],
      options: ['PENDING', 'CHECKOUT', 'CAPTURE', 'KO', 'REFUNDED'],
      label: this.appService.getTraduccion('finance.payment.searcher.status')
    });
    this.fieldFilters.push({
      name: 'type',
      type: 'select',
      multiple: false,
      value: '',
      values: [],
      options: ['INPERSON', 'ONLINE'],
      label: this.appService.getTraduccion('finance.payment.searcher.type')
    });
    this.fieldFilters.push({
      name: 'createdAt',
      type: 'date',
      multiple: false,
      value: '',
      values: [moment().subtract(1, 'M').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      options: null,
      label: this.appService.getTraduccion('finance.payment.searcher.date')
    });
    this.fieldFilters.push({
        name: 'customerId',
        label: this.appService.getTraduccion('finance.payment.searcher.user'),
        type: 'user-search',
        multiple: false,
        value: '',
        values: [],
        options: [],
        searchField: 'email',
        noDataLabel: 'finance.payment.assing.selectedUser.nodata',
        placeholder: 'Ej. Ana, ana@correo.com, +34...'
    });
    this.fieldFilters.push({
      name: 'telephoneNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.payment.searcher.telephoneNumber')
    });
    this.fieldFilters.push({
      name: 'email',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.payment.searcher.email')
    });
    this.fieldFilters.push({
      name: 'invoiceNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.payment.searcher.invoiceNumber')
    });
    this.fieldFilters.push({
      name: 'ticketNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.payment.searcher.ticketNumber')
    });

    this.accions = ["EXCEL"]

    this.selection.changed.subscribe(rows => {
      if (rows.source.isEmpty()) {
        this.massiveAccions.forEach(accion => accion.enabled = false);
      } else {
        this.massiveAccions.forEach(accion => accion.enabled = true);
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this.searchSub?.unsubscribe();
    this.summarySub?.unsubscribe();
  }

  /** Header checkbox helpers */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.validationAction(row) && this.selection.select(row));
  }

  openModal(payment: PaymentModel) {
    const isNew: boolean = payment.uuid == undefined ? true : false;
    let dialogRef = this.dialog.open(PaymentModalContent, {
      panelClass: 'responsive-dialog',
      data: { paymentUuid: payment.uuid, isNew: isNew }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchPayments());
  }

  assingCustomerModal() {
    let dialogRef = this.dialog.open(PaymentAssingModalContent, {
      panelClass: 'responsive-dialog',
      data: { selectedRows: this.selection.selected }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchPayments());
  }

  generateInvoiceModal() {
    let dialogRef = this.dialog.open(PaymentGenerateInvoiceModalContent, {
      panelClass: 'responsive-dialog',
      data: { selectedRows: this.selection.selected }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchPayments());
  }

  /**
   * 
   * @param event example: { length: 155, pageIndex: 1, pageSize: 50, previousPageIndex: 0 }
   */
  onPageChange(event: PageEvent) {
    //console.log(event);

    const page = event ? event.pageIndex : this.pageIndex;
    const size = event ? event.pageSize : this.pageSize;

    this.searchPayments({action: 'PAGE_CHANGE', page: page, size: size});
  }

  onClickMassiveAction(value: string) {
    if (value == 'assign_payment') {
      this.assingCustomerModal();
    } else if (value == 'generate_invoices') {
      this.generateInvoiceModal();
    } else {
      alert('error, acción no seleccionada');
    }
  }

  onChangeMassiveActionSelected(value: string) {
    this.massiveActionSelected = value;
  }

  validationAction(payment: PaymentModel): boolean {
    if (this.massiveActionSelected == 'assign_payment') {
      return true;
    } else if (this.massiveActionSelected == 'generate_invoices') {
      return true;
      return payment.invoice != null && payment.invoice.idClient != null && payment.invoice.idClient != '';
    } else {
      return false;
    }
  }

  isCancelable(payment: PaymentModel):boolean{
    return payment.type == 'ONLINE';
  }


  setOpen(payment?: PaymentModel) {
    this.openModal(Object.assign({}, payment));
  }

  cancelPayment(payment: PaymentModel) {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.paymentCancel(payment.uuid).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  mapAsFilters(fieldFilters: FieldFilter[]) {
    let filters:FilterModel[] = [];
    let map = [];
    map['date'] = OperatorFilterEnum.BETWEEN;
    map['datetime'] = OperatorFilterEnum.BETWEEN;
    map['time'] = OperatorFilterEnum.BETWEEN;
    map['text'] = OperatorFilterEnum.LIKE;
    map['select'] = OperatorFilterEnum.EQUALS;
    map['number'] = OperatorFilterEnum.EQUALS;
    map['user-search'] = OperatorFilterEnum.EQUALS;
    
    for (let fieldFilter of fieldFilters) {
      if ((fieldFilter.value != null && fieldFilter.value != '') || (fieldFilter.values != null && fieldFilter.values.length > 0)) {
        let values:string[] = [...fieldFilter.values]
        if (fieldFilter.name == 'createdAt') {
          values = Utils.mapLocalDateRangeToUtc(values);
        }
        filters.push({
            field: fieldFilter.name,
            operator: fieldFilter.type === 'select' && fieldFilter.multiple ? OperatorFilterEnum.IN : map[fieldFilter.type],
            value: fieldFilter.value,
            values: values
        });
      }
    }
    return Utils.generateFilters(filters);
  }

  submit(action:string){
    this.searchPayments({action: action});
  }

  searchPayments({ page=this.pageIndex, size=this.pageSize, action=null }: { page?: number; size?: number; action?: string; } = {}) {
    let filters = this.mapAsFilters(this.fieldFilters);
    Log.debug('filters', {filters});
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + page + '&size=' + size;

    if (action == null || action == 'PAGE_CHANGE') {
      this.state = 'loading';
      this.searchSub?.unsubscribe();
      this.summarySub?.unsubscribe();

      this.searchSub = this.restService.searchPayments(filters + sort + pageSize).subscribe({
        next: (result) => {
          this.payments = result;
          this.dataSource.data = result?.content ?? [];
          this.totalElements = result?.totalElements ?? 0;
          this.pageIndex = result?.pageNumber ?? page;
          this.selection.clear();
          this.state = 'loaded';
        },
        error: () => {
          this.state = 'error';
        }
      });

      if (action == null) {
        this.summarySub = this.restService.getResumenPayments(filters + sort).subscribe({
          next: (result) => {
            this.resumen = result ?? {};
          },
          error: () => {
            this.resumen = {};
          }
        });
      }

    } else if(action == 'EXCEL') {
      this.download(action);
    }
  }
  
  download(type: string) {
    if (type == 'EXCEL') {
      this.getReport();
    }
  }

  getReport() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=createdAt,desc';
    this.restService.getPaymentReport(filters + sort).subscribe({
      next: (response: Blob) => {
        const createdAtRange = this.mapAsDate('createdAt') || [];
        const filename = `payments-${createdAtRange[0] || 'from'}_${createdAtRange[1] || 'to'}.xlsx`;
        const blob = response instanceof Blob
          ? response
          : new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');

        downloadLink.href = url;
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        Log.error('Error downloading payment report', error);
        this.appService.showDangerToast('Error al descargar el reporte');
      }
    });
  }

  totalFacturado() {
    let sum = 0;
    this.payments.content.forEach(payment => {
      sum += payment.totalPrice;
    });
    return sum;
  }

  mapAsDate(fieldName: string): string[] {
    let field = this.fieldFilters.find(i => i.name == fieldName);
    if (field.values) {
      return field.values;
    }
  }

  onPaymentTableAction(event: DataTableActionEvent<PaymentModel>) {
    if (event.action.key === 'cancel') {
      this.cancelPayment(event.row);
    }
  }

  getPaymentStatusTone(status?: string): DataTableBadgeTone {
    switch (status) {
      case 'CAPTURE':
      case 'CHECKOUT':
        return 'success';
      case 'PENDING':
        return 'warning';
      case 'KO':
        return 'danger';
      default:
        return 'neutral';
    }
  }

  getPaymentTypeTone(type?: string): DataTableBadgeTone {
    switch (type) {
      case 'INPERSON':
        return 'success';
      case 'ONLINE':
        return 'info';
      default:
        return 'neutral';
    }
  }

}

type PaymentStatus = 'CAPTURE' | 'REFUND' | 'PENDING' | string;

@Component({
  selector: 'app-payment-modal-content',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss']
})
export class PaymentModalContent implements OnInit {
  payment: PaymentModel;
  reservationCols: (keyof DataTicketProductModel | 'tax')[] = ['name', 'amount', 'basePrice', 'tax', 'total'];
  reservationsDS = new MatTableDataSource<any>([]);

  get paymentOrderUuid(): string {
    return this.payment?.cart?.orderUuid || '';
  }

  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { paymentUuid: string },
    public dialogRef: MatDialogRef<PaymentModalContent>,
    private restService: RestService,
    public appService: AppService
  ) {

  }

  ngOnInit(): void {
    this.getPayment();
  }

  getPayment(){
    this.restService.getPayment(this.data.paymentUuid).subscribe((result: PaymentModel) => {
      const rows = (result.dataTicket.products || []).map(r => ({
        ...r,
        tax: '21%'
      }));
      //console.log('rows', rows);
      this.reservationsDS.data = rows;
      this.payment = result;
    });
  }

  statusClass(s?: PaymentStatus) {
    switch (s) {
      case 'PENDING': return 'chip-success';
      case 'CHECKOUT': return 'chip-success';
      case 'CAPTURE': return 'chip-success';
      case 'VOIDED': return 'chip-warn';
      case 'KO': return 'chip-error';
      case 'REFUNDED': return 'chip-warn';
      default: return 'chip-neutral';
    }
  }

  refundStatusClass(s?: PaymentStatus) {
    switch (s) {
      case 'PENDING': return 'chip-success';
      case 'PROCESSED': return 'chip-warn';
      case 'FAILED': return 'chip-error';
      default: return 'chip-neutral';
    }
  }

  copy(text?: string) {
    if (!text) { return; }
    navigator.clipboard?.writeText(text);
    this.snack.open('Copiado al portapapeles', 'OK', { duration: 1800 });
  }

  downloadTicket(uuid:string, ticketNumber:string) {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.snack.open('Descargando ticket…', '', { duration: 1500 });
    this.restService.getTicketBase64(uuid, ticketNumber).subscribe(result => {
      let pdfWindow = window.open("");
      pdfWindow.document.write(
        "<head><title>Invoice " + ticketNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )

    });
  }

  downloadInvoice(invoiceNumber:string) {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.snack.open('Descargando factura', '', { duration: 1500 });
    this.restService.getInvoiceBase64(invoiceNumber).subscribe(result => {
      //console.log('getInvoiceBase64', result);

      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<head><title>Invoice " + invoiceNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )

    });
  }

  generateInvoice() {
    let dialogRef = this.dialog.open(PaymentGenerateInvoiceModalContent, {
      panelClass: 'responsive-dialog',
      data: { selectedRows: [this.payment] }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.getPayment());
  }

  openAssignDialog() {
    let dialogRef = this.dialog.open(PaymentAssingModalContent, {
      panelClass: 'responsive-dialog',
      data: { selectedRows: [this.payment] }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.getPayment());
  }

  close() {
    this.dialogRef.close();
  }


}

@Component({
  selector: 'app-payment-assing-modal-content',
  templateUrl: './payment-assing-modal.component.html',
  styleUrls: ['./payment-assing-modal.component.scss']
})
export class PaymentAssingModalContent {

  selectedRows: PaymentModel[];
  dataSource = new MatTableDataSource<PaymentModel>;
  displayedColumns = ['uuid', 'date', 'amount', 'status'];
  searchCtrl = new FormControl<string | UserModel>('');
  assigning$ = new BehaviorSubject<boolean>(false);
  selectedUser: UserModel | null = null;
  mode: string = 'assign';

  selectedCount: number = 0;
  totalAmount: number = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private snack: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { selectedRows: PaymentModel[] },
    public dialogRef: MatDialogRef<PaymentAssingModalContent>,
    private restService: RestService,
    public appService: AppService
  ) {
    this.selectedRows = data.selectedRows;
    this.dataSource = new MatTableDataSource(this.selectedRows);
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  displayUser = (u?: UserModel) => (u ? `${u.username} · ${u.email}` : '');

  onPick(u: UserModel, ev: any) {
    if (ev?.isUserInput) this.selectedUser = u;
  }

  onChangeMode() {
    if (this.mode == 'unassign') {
      this.clear();
    }
  }


  clear() {
    this.searchCtrl.setValue('');
    this.selectedUser = null;
  }

  close() {
    this.dialogRef.close();
  }

  assingCustomerMassive() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    const requests = this.selectedRows.map(payment => {
      //console.log('assingCustomer', this.selectedUser.id, payment);
      return this.restService.assingCustomer(payment.uuid, this.selectedUser.id).pipe(
        map(res => ({ payment: payment, ok: true })),
        catchError(err => of({ invoice: null, ok: false }))
      );
    });

    forkJoin(requests).subscribe((results: { ok: boolean, payment: PaymentModel }[]) => {
      //console.log('assingCustomer:results', results);
      const updated:boolean = results?.some(r => r.ok === true) ?? false;
      for (let result of results) {
        if (result.ok) {
          this.appService.showSuccessToast(`El pago ${result.payment.uuid} se han asignado correctamente`);
        }
      }
      this.dialogRef.close({ updated: updated });
    });

  }


  unassingCustomerMassive() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    const requests = this.selectedRows.map(payment => {
      //e.log('unassingCustomer', payment);
      return this.restService.unassingCustomer(payment.uuid).pipe(
        map(res => ({ payment: payment, ok: true })),
        catchError(err => of({ invoice: null, ok: false }))
      );
    });

    forkJoin(requests).subscribe((results: { ok: boolean, payment: PaymentModel }[]) => {
      //console.log('unassingCustomer:results:', results);
      const updated:boolean = results?.some(r => r.ok === true) ?? false;
      for (let result of results) {
        if (result.ok) {
          this.appService.showSuccessToast(`El pago ${result.payment.uuid} se ha desasignado correctamente`);
        }
      }
      this.dialogRef.close({ updated: updated });
    });

  }

}


@Component({
  selector: 'app-payment-generate-invoice-modal-content',
  templateUrl: './payment-generate-invoice-modal.component.html',
  styleUrls: ['./payment-generate-invoice-modal.component.scss']
})
export class PaymentGenerateInvoiceModalContent implements OnInit {

  selectedRows: PaymentModel[];
  dataSource = new MatTableDataSource<PaymentModel>;
  displayedColumns = ['id', 'date', 'amount', 'status', 'invoiceToGenerate'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private snack: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { selectedRows: PaymentModel[] },
    public dialogRef: MatDialogRef<PaymentAssingModalContent>,
    private restService: RestService,
    public appService: AppService
  ) {
    
  }

  ngOnInit(): void {
    this.selectedRows = this.data.selectedRows;
    this.dataSource = new MatTableDataSource(this.selectedRows);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  close() {
    this.dialogRef.close();
  }

  generateInvoiceMassive() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    const requests = this.selectedRows.map(payment => {
      //console.log('generateInvoive', payment);
      return this.restService.generateInvoive(payment.uuid).pipe(
        map(res => ({ payment: payment, ok: true })),
        catchError(err => of({ invoice: null, ok: false }))
      );
    });

    forkJoin(requests).subscribe((results: { ok: boolean, payment: PaymentModel }[]) => {
      //console.log('generateInvoive:results:', results);
      const updated:boolean = results?.some(r => r.ok === true) ?? false;
      for (let result of results) {
        if (result.ok) {
          this.appService.showSuccessToast(`Se ha generado la factura del pago ${result.payment.uuid}`);
        }
      }
      this.dialogRef.close({ updated: updated });
    });
  }

}
